export const getCredentials = (currentData, creds) => {
  let credObj = {};

  if (currentData.selectedAuthOption === "WizardBasicAuth") {
    credObj = {
      username: currentData.jiraUserEmail,
      password: currentData.jiraUserPassword,
    };
  } else {
    const cred = creds.find((c) => c.id === currentData.credential.value);
    credObj = {
      username: cred.data.username,
      password: cred.data.password,
    };
  }
  return credObj;
};